﻿// carousel
export const CAROUSEL_ELEMENTS = () => document.querySelectorAll('[data-identity="carousel"]');

export const MOBILE_CAROUSEL_ELEMENTS = () => document.querySelectorAll('[data-identity="mobile-carousel"]');

export const CAROUSEL_AUTOPLAY_INTERVAL = 5000;

// lazy load
export const LAZY_LOAD_IMAGE_ELEMENTS = () => document.querySelectorAll('[data-identity="lazy-load"]');